import axios from "../../axios";

export const getCashflowAnalysis = async (accountId) => {
  try {
    const response = await axios.get(
      `/api/v3/analysis/cashflowAnalysis?accountId=${accountId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};
